import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BooksView } from "../VIEW/BooksView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function BooksPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.BOOKS}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <BooksView uid={user.uid} />;
}

export default BooksPage;
